module.exports = __webpack_public_path__ + "static/media/isdoctorplan-ent1@3x.c33711f4.png";